<nav class="cat__menu-left">
  <!-- Recolher/expandir é o oab-sidebar-toggle no header; submenus são accordion
  nativo no MenuLeftV2Component (o lock/pin do CleanUI + jQuery foram removidos). -->
  <div class="cat__menu-left__logo">
    <a routerLink="/" class="oab-logo">
      <img class="oab-logo__full" src="assets/modules/dummy-assets/common/img/oab-seguranca.png" alt="OAB Segurança" />
      <span class="oab-logo__mini" aria-hidden="true"><i class="fa fa-shield"></i></span>
    </a>
    <button type="button" class="oab-sidebar-toggle" (click)="toggleCollapse()"
      [attr.aria-label]="collapsed ? 'Expandir menu' : 'Recolher menu'" title="Recolher / expandir menu">
      <i class="fa" [class.fa-angle-left]="!collapsed" [class.fa-angle-right]="collapsed" aria-hidden="true"></i>
    </button>
  </div>

  <div class="cat__menu-left__inner">
    <ul class="cat__menu-left__list cat__menu-left__list--root">
      @for (i of nodes(); track i) {
        <li
          class="cat__menu-left__item"
          [class.cat__menu-left__submenu]="i.children.length > 0"
          [class.cat__menu-left__submenu--toggled]="i.children.length > 0 && i.expanded"
          [routerLinkActive]="['cat__menu-left__item--active']"
          >
          @if (i.children.length == 0) {
            <a [routerLink]="[i.routerLink]" [title]="i.name">
              <span class="cat__menu-left__initial">{{ (i.name || '?').charAt(0) }}</span>
              <span class="cat__menu-left__text">{{ i.name }}</span>
            </a>
          } @else {
            <a href="javascript: void(0);" [title]="i.name" (click)="toggleSubmenu(i)"
              role="button" [attr.aria-expanded]="!!i.expanded">
              <i class="cat__menu-left__icon" [ngClass]="i.icon"></i>
              <span class="cat__menu-left__text">{{ i.name }}</span>
            </a>
          }
          @if (i.children.length > 0) {
            <ul class="cat__menu-left__list">
              @for (sub of i.children; track sub) {
                <li
                  class="cat__menu-left__item"
                  [routerLinkActive]="['cat__menu-left__item--active']"
                  >
                  <a [routerLink]="[sub.routerLink]" [title]="sub.name">
                    <span class="cat__menu-left__initial">{{ (sub.name || '?').charAt(0) }}</span>
                    <span class="cat__menu-left__text">{{ sub.name }}</span>
                  </a>
                </li>
              }
            </ul>
          }
        </li>
      }

      <li class="cat__menu-left__divider"><!-- --></li>
    </ul>
  </div>

  <!-- Item do servidor fixado no rodapé (acima do perfil): Base de Conhecimento (documentação). -->
  @if (bottomNode(); as kb) {
    <div class="cat__menu-left__static">
      <ul class="cat__menu-left__list">
        <li class="cat__menu-left__item" [routerLinkActive]="['cat__menu-left__item--active']">
          <a [routerLink]="[kb.routerLink]" [title]="kb.name">
            <span class="cat__menu-left__initial"><i class="fa fa-book" aria-hidden="true"></i></span>
            <span class="cat__menu-left__text">{{ kb.name }}</span>
          </a>
        </li>
      </ul>
    </div>
  }

  <!-- Rodapé da sidebar: usuário + ações (substitui a área do usuário da topbar) -->
  <div class="cat__menu-left__footer">
    <oab-profile-dropdown-v2></oab-profile-dropdown-v2>
  </div>
</nav>

<div class="cat__menu-left__backdrop cat__menu-left__action--backdrop-toggle"><!-- --></div>

